import { render } from "./BirthDetail.vue?vue&type=template&id=aa581e78&scoped=true"
import script from "./BirthDetail.vue?vue&type=script&lang=js"
export * from "./BirthDetail.vue?vue&type=script&lang=js"

import "./BirthDetail.vue?vue&type=style&index=0&id=aa581e78&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa581e78"]])

export default __exports__